// src/features/dashboard/superadmin/OrganisationsTable.jsx
import React, { useState, useMemo } from 'react';

export const OrganisationsTable = ({ organisations, onEdit, onDelete, onManageAdmins }) => {
  const [search, setSearch] = useState("");

  const filtered = useMemo(() => {
    if (!search.trim()) return organisations;
    const q = search.toLowerCase().trim();
    return organisations.filter(o =>
      o.organisationId.toLowerCase().includes(q) ||
      o.organisationName.toLowerCase().includes(q) ||
      o.organisationCode.toLowerCase().includes(q)
    );
  }, [organisations, search]);

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <div className="p-4 border-b border-gray-200 flex flex-wrap gap-3 items-center justify-between">
        <div className="flex flex-wrap gap-2">
          <input
            type="text"
            placeholder="Search organisations..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="border rounded px-3 py-1 text-sm"
          />
        </div>
        <button
          onClick={() => onEdit(null)}
          className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 text-sm"
        >
          + Add Organisation
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">ID</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Name</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Code</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {filtered.length === 0 ? (
              <tr><td colSpan="5" className="px-4 py-3 text-center text-gray-500">No organisations found.</td></tr>
            ) : (
              filtered.map((org) => (
                <tr key={org.rowNumber}>
                  <td className="px-4 py-2">{org.organisationId}</td>
                  <td className="px-4 py-2">{org.organisationName}</td>
                  <td className="px-4 py-2">{org.organisationCode}</td>
                  <td className="px-4 py-2">
                    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${org.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                      {org.status}
                    </span>
                  </td>
                  <td className="px-4 py-2">
                    <button onClick={() => onEdit(org)} className="text-blue-600 hover:underline mr-2 text-sm">Edit</button>
                    <button onClick={() => onDelete(org)} className="text-red-600 hover:underline mr-2 text-sm">Delete</button>
                    <button onClick={() => onManageAdmins(org)} className="text-purple-600 hover:underline text-sm">Manage Admins</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};